import React from 'react'
import { cartData } from './Firebasedata';
import basket from './basketitem';
function CheckBackend(props) {
   /*// const cartData = fn('mahe')
    console.log(props.cartData);
    console.log(props.msg)
  return (
    <div>CheckBackend</div>
  )*/
 
  console.log(basket)
  return <></>
}

export default CheckBackend